import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const getStoreWarehouseQrCodeByStatus = (storeId,data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/qrcode-by-status',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getStoreWarehouseQrCodeByStatusSearch = (storeId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/order-qrcode-by-status',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getReadyGarmentToSendToWarehouse = (storeId,data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/bulk-qrcode',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getStoreWarehouseInfo = storeId => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/warehouse/api/secure/v1/store/' + storeId + '/ware-house',
    headers: getHeaders(),
  });
};

export const getStoreWarehouseInfoByWarehouse = warehouseId => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/v1/ware-house/' +
      warehouseId +
      '/store',
    headers: getHeaders(),
  });
};

export const toGenerateChallan = (warehouseId) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/warehouse/api/secure/v1/ware-house-store/' +
      warehouseId +
      '/challan/SENT_TO_WARE_HOUSE',
    headers: getHeaders(),
    // data: JSON.stringify(data),
  });
};

export const postSendToWareHouse = (storeId,data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/send-to-ware-house',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};